import React, { Component } from 'react';
import FormatMessage from '../../messages/FormatMessage';
import { HatApplicationPermissions } from '../../interfaces/hat-application.interface';

type Props = {
  appName: string;
  permissions: HatApplicationPermissions;
};

class HmiPermissions extends Component<Props> {
  static processPermissionRoles(
    roles: Array<{ role: string; detail?: string }>
  ): Array<JSX.Element | null> {
    return roles.map(role => {
      switch (role.role) {
        case 'namespaceread':
          return (
            <FormatMessage
              id={`hmi.permissions.read`}
              values={{ name: role.detail }}
            />
          );
        case 'namespacewrite':
          return (
            <FormatMessage
              id={`hmi.permissions.write`}
              values={{ name: role.detail }}
            />
          );
        default:
          return null;
      }
    });
  }

  render() {
    const permissionProps = this.props.permissions;
    const elements = HmiPermissions.processPermissionRoles(
      permissionProps.rolesGranted
    );

    return (
      <div className={'hmi-permissions'}>
        {elements && (
          <div className={'hmi-permissions-content'}>
            <div className={'hmi-card-title'}>
              <FormatMessage
                id={`hmi.permissions.appAbleTo`}
                values={{ name: this.props.appName }}
              />
            </div>
            <ul className="instruction-list">
              {elements.map((value, index) => {
                if (!value) return null;

                return (
                  <li className="list-item" key={index}>
                    {value}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default HmiPermissions;
